import Navbar from "../Components/Navbar";
import Header from "../Components/Header";
import A from "../Components/A";
import B from "../Components/B";
import C from "../Components/C";
import D from "../Components/D";
import E from "../Components/E";
import GetApp from "../Components/GetApp";
import Footer from "../Components/Footer";
import "../Styles/Home.css";

export default function Home() {
  return (
    <>
      <Navbar />
      <Header />
      {/* All grids*/}
      <A />
      <B />
      <C />
      <D />
      <E />
      <GetApp />
      <Footer />
      {/*  */}
    </>
  );
}
